import { render, staticRenderFns } from "./ViewArticleLayout.vue?vue&type=template&id=5b8224d8&"
import script from "./ViewArticleLayout.vue?vue&type=script&lang=js&"
export * from "./ViewArticleLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports